<template>
  <fieldset>
    <RadioGroup v-model="selectedOption" class="mt-2 grid grid-cols-2 gap-3 md:grid-cols-5">
      <RadioGroupOption as="template" v-for="option in options" :key="option" :value="option"
        v-slot="{ active, checked }">
        <div
          :class="['cursor-pointer outline-none',
            active ? '' : '',
            checked ? 'bg-blue-600 text-white border border-transparent hover:bg-blue-500' : 'bg-slate-100 border border-slate-300 text-slate-500 hover:bg-slate-200',
            !active && !checked ? '' : '',
            active && checked ? '' : '', 'flex items-center justify-center rounded-md px-3 py-3 text-sm font-semibold sm:flex-1'
          ]">
          {{ option }}
        </div>
      </RadioGroupOption>
    </RadioGroup>
  </fieldset>
</template>

<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { RadioGroup, RadioGroupOption } from '@headlessui/vue'

// Define the props correctly with the modelValue for v-model
const props = defineProps({
  modelValue: {
    type: [String, null], // Adjust type as per your expected value types
    required: true
  },
  options: {
    type: Array,
    required: true
  }
})

// Create a reactive variable to sync with v-model
const selectedOption = ref(props.modelValue);
const emit = defineEmits(['update:modelValue']);
watch(selectedOption, (newValue) => {
  emit('update:modelValue', newValue);
})
</script>